import React, { useContext } from 'react'
import { string, object } from 'prop-types'
import styled, { css } from 'styled-components'
import { navigate } from 'gatsby'

import { setCartLineItems } from 'utils/buyFlow'

import CheckoutContext from 'contexts/Checkout'
import { EngravingContext } from 'components/buy/Engraving/EngravingContext'
// import Icon from 'components/Icon'
import Button from 'components/button/Button'
import EngravingSummary from 'components/buy/Engraving/EngravingSummary'
import * as spacing from 'styles/spacing'
import { white, borderColor } from 'styles/colors'
import { media } from 'styles/media'
import { H3 } from 'styles/typography'
import { summaryHeight } from 'styles/global'

export const Container = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 0 ${spacing.large};
  background-color: ${white};
  border-top: 1px solid ${borderColor};
  height: 73px;
  z-index: 20;

  ${props =>
    props.engraving &&
    css`
      padding: 0 !important;
      height: auto !important;
    `}

  ${media.medium`
    padding: ${spacing.large};
    left: 50%;
    height: ${summaryHeight};
  `};

  ${media.large`
    left: 45%;
  `};
`

export const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${media.medium`
    justify-content: center;
  `};
`

export const Price = styled(H3)`
  margin: 0;
  margin-left: auto;

  ${media.medium`
    margin-left: 0;
  `};
`

export const StyledButton = styled(Button)`
  min-width: 180px;
  margin-left: ${spacing.large};

  ${media.medium`
    width: 220px;
  `};

  ${media.large`
    width: 280px;
    margin-left: ${spacing.xLarge};
  `};

  ${media.xLarge`
    width: 320px;
    margin-left: ${spacing.xxLarge};
  `};
`

export const ArrowButton = styled.button`
  display: flex;
`

const BuySummary = ({ collection, totalPrice, selectedProduct }) => {
  const { loading, addLineItemsToCart } = useContext(CheckoutContext)
  const { visible, engraving, resetEngraving } = useContext(EngravingContext)

  const goToCart = async () => {
    const lineItems = setCartLineItems(collection, engraving)
    await addLineItemsToCart(lineItems)
    resetEngraving()
    navigate('/cart')
  }

  return (
    <Container engraving={visible}>
      <Inner>
        {!visible ? (
          <>
            <Price>{totalPrice}</Price>
            {!selectedProduct?.node?.tags.includes('engravable') ? (
              <>
                <StyledButton theme="primary" onClick={goToCart} isLoading={loading} disabled={loading}>
                  {'Add items & go to cart'}
                </StyledButton>
              </>
            ) : (
              <>
                {!engraving.proceeded ? (
                  <div data-tip="Please select customizable options for your device.">
                    <StyledButton theme="primary" isLoading={loading} disabled>
                      {'Add items & go to cart'}
                    </StyledButton>
                  </div>
                ) : (
                  <StyledButton theme="primary" onClick={goToCart} isLoading={loading} disabled={loading}>
                    {'Add items & go to cart'}
                  </StyledButton>
                )}
              </>
            )}
          </>
        ) : (
          <EngravingSummary />
        )}
      </Inner>
    </Container>
  )
}

BuySummary.propTypes = {
  collection: object.isRequired,
  totalPrice: string.isRequired,
  selectedProduct: object
}

export default BuySummary
